module.exports = __webpack_public_path__ + "img/2.5821b1f6.svg";